export class EpalUnitDetails {
  buildingId: string;
  buildingName : string;
  eloviewSerialNumber : string;
  simCardICCID1 : string;
  simCardICCID2 : string;
  Units : UnitDetails[];
}

class UnitDetails
{
  unitNumber?: string;
  cpidUuid?: string;
  isIotCommissioned?: string;
}
